import {
  RATE_MASTER_FETCH_DATA,
  RATE_MASTER_ENABLE_LOADING,
  RATE_MASTER_FETCH_ERROR,
  RATE_MASTER_DISABLE_LOADING,
  RATE_MASTER_SET_FILTERS,
  RATE_MASTER_SET_PAGINATION,
  RATE_MASTER_RESET_FILTERS,
  RATE_MASTER_RESET_PAGINATION,
  RATE_MASTER_SET_PREV_PAGINATION,
  RATE_MASTER_GET_MASTER,
} from './constants';

import {
  RateDigitisationFetchAllRates, RateDigitisationFetchMaster,
} from 'src/api/rateMasterRateDigitisation';

import { getLastSortedColumnValue, getLastRowId } from '../utils/pagination';

export const getAllDataSetFilter = val => async (dispatch) => {
  dispatch({
    type: RATE_MASTER_SET_FILTERS,
    data: val,
  });
  dispatch({
    type: RATE_MASTER_RESET_PAGINATION,
  });
  dispatch(fetchAllData());
};

export const getAllDataResetFilter = (apiCall = true) => async (dispatch) => {
  dispatch(
    {
      type: RATE_MASTER_RESET_FILTERS,
    });
  if (apiCall) dispatch(fetchAllData());
};

export const getAllDataSetPagination = pagination => async (dispatch) => {
  dispatch({
    type: RATE_MASTER_SET_PAGINATION,
    data: { ...pagination },
  });
  dispatch(fetchAllData());
};

export const getAllDataResetPagination = () => async (dispatch) => {
  dispatch({
    type: RATE_MASTER_RESET_PAGINATION,
  });
  dispatch(fetchAllData());
};

export const fetchAllData = (fetchMaster = false) => async (dispatch, getState) => {
  dispatch(
    {
      type: RATE_MASTER_ENABLE_LOADING,
    });

  const selectedFilters = getState().rateMasterReducer.selectedFilters;
  const mode = selectedFilters.mode || 'FCL';
  const polList = selectedFilters.polList || [];
  const podList = selectedFilters.podList || [];
  const carrierList = selectedFilters.carrierList || [];
  const containersList = selectedFilters.containersList || [];
  const isDirectShipment = selectedFilters.isDirectShipment || false;
  const includeExpiredRates = selectedFilters.includeExpiredRates || false;
  const pagination = getState().rateMasterReducer.pagination;

  const body = {
    ...selectedFilters,
    mode,
    polList,
    podList,
    carrierList,
    containersList,
    isDirectShipment,
    includeExpiredRates,
    lastRowId: getLastRowId(pagination),
    currentPageNumber: pagination.currentPageNumber,
    resultPerPage: Number(pagination.resultPerPage),
    nextOrPrev: pagination.nextOrPrev,
    lastSortedColumnValue: getLastSortedColumnValue(pagination),
  };
  const response = await RateDigitisationFetchAllRates(body);
  if (response.isSuccess) {
    dispatch({
      type: RATE_MASTER_SET_PAGINATION,
      data: response,
    });
    dispatch({
      type: RATE_MASTER_FETCH_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: RATE_MASTER_FETCH_ERROR,
    });
  }

  if (fetchMaster) {
    dispatch(setRateDigitisationMasterData());
  }
  dispatch({
    type: RATE_MASTER_DISABLE_LOADING,
  });
};

export const setPrevPagination = (callRatesData = true) => async(dispatch, getState) => {
  dispatch({
    type: RATE_MASTER_SET_PREV_PAGINATION,
  });
  if (callRatesData) dispatch(fetchAllData());
};

export const setRateDigitisationMasterData = () => async (dispatch) => {
  const responseMaster = await RateDigitisationFetchMaster();
    if (responseMaster.isSuccess) {
      dispatch({
        type: RATE_MASTER_GET_MASTER,
        data: responseMaster.data,
      });
    }
}
